// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import CheckOrdersOrderSummary from './checkOrdersOrderSummary';
import React from 'react';

function CheckOrdersOrderSummaryPage () {

    return (
        <AuthenticatedPage className="atp-page atp-check-orders-order-summary-page">
            <CheckOrdersOrderSummary />
        </AuthenticatedPage>
    );

}
CheckOrdersOrderSummaryPage.displayNAme = 'CheckOrdersOrderSummaryPage';

export default CheckOrdersOrderSummaryPage;
